enum Brand {
  Taf = 'taf',
  wefox = 'wefox',
  DHMR = 'dhmr',
}

export default Brand;
